import { Card, Badge, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { safeDecrypt } from "./uwin-decrypt";
import { formatAgeRangeDisplay, formatRelativeDateDisplay, formatSessionNameDisplay } from "../../../helpers/common-uwinhelper";

const SessionCard = ({
    item,
    status,
    selectedFacility,
    selectedSessionSite,
    sessionData,
}) => {
    const navigate = useNavigate();
    const [hovered, setHovered] = useState(false);
    const isOngoing = status === "ONGOING";

    // Apply business logic transformations for display
    const displaySessionName = item ? formatSessionNameDisplay(item) : "";
    const displayAgeRange = item ?formatAgeRangeDisplay(item) : "";
    const displayDate = formatRelativeDateDisplay(item?.display_time);

    const handleViewDetails = () => {
    navigate(`/Sessions`, {
        state: {
            sessionId: item.session_id,
            selectedFacility,
            selectedSessionSite,
            sessionData,
        },
    });
    };

    return (
        <Card
            onClick={handleViewDetails}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && handleViewDetails()}
            className={`border-0 rounded-4 bg-white h-100 ${
                hovered ? "shadow-lg" : "shadow-sm"
            }`}
            style={{
                cursor: "pointer",
                transform: hovered ? "translateY(-4px)" : "translateY(0)",
                transition: "all 0.2s ease-in-out",
            }}
        >
            <Card.Body className="p-4">
                {/* Header */}
                <div className="d-flex justify-content-between align-items-start mb-3">
                    <div>
                        <div className="text-uppercase text-secondary small">
                            Session Name
                        </div>

                        <div className="fw-semibold fs-6 mt-1 text-dark">
                            {displaySessionName}
                        </div>
                    </div>

                    <Badge
                        pill
                        bg={isOngoing ? "success" : "primary"}
                        className="px-3 py-1 fw-medium"
                    >
                        {isOngoing ? "ONGOING" : "YET TO START"}
                    </Badge>
                </div>

                {/* Info Grid */}
                <Row className="gy-2">
                    <Col md={4}>
                        <div className="text-secondary small text-uppercase">
                            Age Group
                        </div>
                        <div className="fw-medium text-dark">
                            {displayAgeRange}
                        </div>
                    </Col>

                    <Col md={5}>
                        <div className="text-secondary small text-uppercase">
                            Date
                        </div>
                        <div className="fw-medium text-dark">
                            {displayDate}
                        </div>
                    </Col>

                    <Col md={3} className="text-md-end">
                        <div className="text-secondary small text-uppercase">
                            Slots Left
                        </div>
                        <div className="fw-semibold text-dark">
                            {item?.slots_left}
                            <i className="bi bi-info-circle ms-1 text-muted"></i>
                        </div>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
};

export default SessionCard;
